/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";
import axios from "axios";
//BASE_URL
const API_URL = process.env.REACT_APP_API_URL;
const CHEF_API_URL = process.env.REACT_APP_CHEF_API_URL;

const getPlans = async (user_id: any) => {
  const response = await axios.post(`${API_URL}get-plan`, { user_id });
  
  return response.data;
};

const getCoupons = async (payload: { couponType: "subscription" | "order" }) => {
  const response = await axios.post(`${API_URL}get-coupons`, payload);
  
  return response.data;
};

// _requests.ts


const unsubscribePlan = async (data: any) => {
  
  
  
  const response = await axios.post(`${API_URL}unsubscribe-plan`, data);
  return response.data;
};
const saveCardDetailsTostripe = async (data: any) => {
  
  
  
  const response = await axios.post(`${API_URL}save-card-stripe`, data);
  return response.data;
};
const createCheckoutSession = async (data: any) => {
  
  
  
  const response = await axios.post(`${API_URL}create-checkout-session`, data);
  return response.data;
};

const getPaymentStatus = async (
  session_id: string,
  subscribedActivePlanId: any
) => {
  

  const response = await axios.post(`${API_URL}payment-status`, {
    session_id,
    subscribedActivePlanId,
  });

  
  return response.data;
};

const verifyStudentDetails = async (data: any) => {
  
  const response = await axios.post(`${API_URL}verify-student`, data);
  
  return response.data;
};

const ProfileDetails = async (id: any) => {
  
  
  
  const response = await axios.post(`${API_URL}view-user/${id}`);
  return response.data;
};

const createTrialSubscription = async (data: any) => {
  
  
  
  const response = await axios.post(`${API_URL}subscription-trial`, data);
  return response.data;
};

const createtSession = async (data: any) => {
  
  
  
  const response = await axios.post(`${API_URL}create-session`, data);
  return response.data;
};
const getPlanForAffiliateUser = async () => {
  const response = await axios.post(`${API_URL}get-plan-affiliate`);
  
  return response.data;
};
const createPromoteKitCheckoutSessionUser = async (data: any) => {
  
  
  
  const response = await axios.post(
    `${API_URL}create-promotekit-session`,
    data
  );
  return response.data;
};

const getPlanForAffiliateChef = async () => {
  const response = await axios.post(`${CHEF_API_URL}get-plan-affiliate`);
  
  return response.data;
};
const createPromoteKitCheckoutSessionChef = async (data: any) => {
  
  
  
  const response = await axios.post(
    `${CHEF_API_URL}create-promotekit-session`,
    data
  );
  return response.data;
};

const FirstPromoterAffiliateAPI = async (data: any) => {
  
  
  
  const response = await axios.post(
    `${API_URL}create-firstpromoter-affiliate`,
    data
  );
  return response.data;
};

const getPaymentStatusChef = async (session_id: string) => {
  

  const response = await axios.post(`${CHEF_API_URL}get-status-session`, {
    session_id,
  });

  
  return response.data;
};
const getPaymentStatusUser = async (session_id: string) => {
  

  const response = await axios.post(`${API_URL}get-status-session`, {
    session_id,
  });

  
  return response.data;
};

const StudentVerificationSendOtp = async (data: any) => {
  

  const response = await axios.post(
    `${API_URL}student-verification-send-otp`,
    data
  );

  
  return response.data;
};
const StudentVerificationVerifyOtp = async (data: any) => {
  

  const response = await axios.post(
    `${API_URL}student-verification-verify-otp`,
    data
  );

  
  return response.data;
};

const StudentVerificationDetails = async (id: any) => {
  

  const response = await axios.get(
    `${API_URL}student-verification-details/${id}`
  );

  
  return response.data;
};
const StudentVerificationUpload = async (data: any) => {
  

  const response = await axios.post(
    `${API_URL}student-verification-studentid`,
    data,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );

  
  return response.data;
};
export {
  createtSession,
  getPlans,
  unsubscribePlan,
  getPaymentStatusChef,
  getPaymentStatusUser,
  createCheckoutSession,
  getPaymentStatus,
  ProfileDetails,
  verifyStudentDetails,
  saveCardDetailsTostripe,
  createTrialSubscription,
  FirstPromoterAffiliateAPI,
  getPlanForAffiliateUser,
  createPromoteKitCheckoutSessionUser,
  getPlanForAffiliateChef,
  createPromoteKitCheckoutSessionChef,
  getCoupons,
  StudentVerificationSendOtp,
  StudentVerificationVerifyOtp,
  StudentVerificationUpload,
  StudentVerificationDetails
};
